exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___i3aeI{display:flex;flex-direction:row}.style__shape___314IF{flex-grow:1;text-align:center}.style__shapeCustomStyle___3d36g{height:80px}.style__linkSharedStyles___3wLv8{border:1px solid #dbdbdc;display:flex;justify-content:center;cursor:pointer;height:40px;background:#fafbfc;margin:0;margin-left:-1px}.style__imageBox___3rzUe{display:flex;align-items:center;justify-content:center;width:30px}.style__active___2pibr{background:#f7d0cb}.style__label___39Xz2{font-family:FuturaStd-Book;font-size:11px;letter-spacing:.3px;color:#000;font-weight:400;display:block;margin-top:8px;text-align:center}.style__disabled___EyRcG{cursor:not-allowed;background-color:#ccc}.style__group___XtaRl{display:flex;align-items:flex-end;margin-left:0}", ""]);

// exports
exports.locals = {
	"container": "style__container___i3aeI",
	"shape": "style__shape___314IF",
	"shapeCustomStyle": "style__shapeCustomStyle___3d36g",
	"linkSharedStyles": "style__linkSharedStyles___3wLv8",
	"linkPrimaryDiamond": "style__linkPrimaryDiamond___1qMHJ style__linkSharedStyles___3wLv8",
	"linkMultiStone": "style__linkMultiStone___1zvKS style__linkSharedStyles___3wLv8",
	"linkDiamondSearch": "style__linkDiamondSearch___TDpBu style__linkSharedStyles___3wLv8",
	"imageBox": "style__imageBox___3rzUe",
	"active": "style__active___2pibr",
	"label": "style__label___39Xz2",
	"disabled": "style__disabled___EyRcG",
	"group": "style__group___XtaRl"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/select-shapes/style.css
// module id = 705
// module chunks = 0